module.exports = __webpack_public_path__ + "static/media/reactcerti.81240388.png";